import { MapPin, Square, Bed, Bath, Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { featuredProperties } from '../mockData';

const propertyImages = [
  'https://customer-assets.emergentagent.com/job_krishnaestate/artifacts/8y9x2dal_2026-01-13.webp',
  'https://customer-assets.emergentagent.com/job_krishnaestate/artifacts/2ufnewwn_2026-01-21.webp',
  'https://customer-assets.emergentagent.com/job_krishnaestate/artifacts/kmcwifdg_unnamed.webp'
];

export const FeaturedProperties = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Featured Properties
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Handpicked premium properties in prime Vrindavan locations
          </p>
        </div>

        {/* Property Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredProperties.filter(p => p.featured).map((property, index) => (
            <Card key={property.id} className="overflow-hidden border-2 border-gray-100 hover:border-orange-300 transition-all duration-300 hover:shadow-2xl group">
              {/* Property Image */}
              <div className="h-56 relative overflow-hidden">
                <img 
                  src={propertyImages[index]} 
                  alt={property.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                {property.featured && (
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-orange-600 text-white">
                      <Star className="w-3 h-3 mr-1 fill-white" />
                      Featured
                    </Badge>
                  </div>
                )}
                <div className="absolute bottom-4 left-4">
                  <Badge className="bg-white/90 text-gray-900">{property.status}</Badge>
                </div>
              </div>

              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{property.title}</h3>
                <div className="flex items-center text-gray-600 mb-4">
                  <MapPin className="w-4 h-4 mr-1 text-orange-600" />
                  <span className="text-sm">{property.location}</span>
                </div>

                <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-100">
                  <div className="flex items-center space-x-4 text-gray-600">
                    {property.bedrooms && (
                      <div className="flex items-center space-x-1">
                        <Bed className="w-4 h-4" />
                        <span className="text-sm">{property.bedrooms}</span>
                      </div>
                    )}
                    {property.bathrooms && (
                      <div className="flex items-center space-x-1">
                        <Bath className="w-4 h-4" />
                        <span className="text-sm">{property.bathrooms}</span>
                      </div>
                    )}
                    <div className="flex items-center space-x-1">
                      <Square className="w-4 h-4" />
                      <span className="text-sm">{property.size}</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-2xl font-bold text-orange-600">{property.price}</p>
                  </div>
                  <Button variant="outline" size="sm" className="border-orange-600 text-orange-600 hover:bg-orange-50">
                    View Details
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button 
            size="lg" 
            className="bg-orange-600 hover:bg-orange-700 text-white"
            onClick={() => window.open('https://wa.me/918679334866?text=Hi, I would like to see all available properties', '_blank')}
          >
            View All Properties
          </Button>
        </div>
      </div>
    </section>
  );
};